import { DashboardLayout } from "@/components/layout";

/**
 * Auth boundary for authenticated routes.
 *
 * Authentication is fully resolved in authenticatedRoute.beforeLoad:
 * - If session is valid → beforeLoad passes, this component renders
 * - If session is invalid → beforeLoad redirects to /login, this never renders
 *
 * No loading spinner needed — the router handles the async auth check
 * before any component in the authenticated subtree renders.
 */
export function AuthGuard() {
  return <DashboardLayout />;
}
